export default __webpack_public_path__ + "img/lapin-6fc93162.png";